import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";

import "apps/messenger/components/Connections/shared/FadedScrollableText.scss";

function FadedScrollableText({ children }) {
	const [ canScroll, setCanScroll ] = useState(false);

	const scrollRef = useCallback((node) => {
		if (node !== null) {
			const nextCanScroll = node.scrollHeight > node.clientHeight;
			setCanScroll(nextCanScroll);
		}
	}, []);

	return (
		<div className="faded-scrollable-text">
			<div
				ref={scrollRef}
				className="faded-scrollable-text-scroll"
			>
				{children}
				{ canScroll && <div className="faded-scrollable-text-scroll-overscroll" /> }
			</div>
			{ canScroll && <div className="faded-scrollable-text-fade" /> }
		</div>
	);
}

FadedScrollableText.propTypes = {
	children: PropTypes.node.isRequired,
};

export default FadedScrollableText;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/shared/FadedScrollableText.jsx